import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupMemberQuitContentProps } from './msg-group-member-quit-content';
import { MsgGroupMemberQuitContent } from './msg-group-member-quit-content';

export interface MsgGroupMemberQuitPreviewProps extends MsgGroupMemberQuitContentProps {}

export const MsgGroupMemberQuitPreview = memo(function MsgGroupMemberQuitPreview({
  message,
}: MsgGroupMemberQuitPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupMemberQuitContent message={message} />
    </LastMessageSystem>
  );
});
